import React, { useEffect, useState } from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import Box from '@mui/material/Box';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
// import { Document, Page, pdfjs } from "react-pdf";
import {
  Alert,
  Button,
  Card,
  CardMedia,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { CancelButton } from '../../../../components/mui/Buttons/Buttons';
import { Icon } from '@iconify/react';
import MotionContainer from '../../../../components/FramerMotion/MotionContainer';
import { compressImage } from '../../../../utils/constants/ImageCompress';
import Loader3D from '../../../../components/Loader/Loader3D';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import GlobalSelectField from '../../../../components/mui/GlobalSelectField';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCartItems,
  getCartItemsSkillx,
  getEmiCartItem,
  makeNextPayment,
} from '../../../../redux/features/cartSlice';
import { useLocation } from 'react-router-dom';
import useResponsive from '../../../../Hooks/useResponsive';
import CircularLoader from '../../../../components/Loader/CircularLoader';
import { pdfjs, Document, Page } from 'react-pdf';
// import pdfWorker from "pdfjs-dist/build/pdf.worker.min.mjs";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { savePaginationData } from '../../../../redux/features/globalDatagridSlice';

const MakeNextPayment = ({ paidItem, handleClose, emi, updateData, paid }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [inrValue, setInrValue] = useState(23);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');
  const dispatch = useDispatch();
  const location = useLocation();
  const [value, setValue] = React.useState(dayjs());
  const [compressesImg, setCompressesImg] = useState(null);

  const [loadingCart, setLoading] = useState(false);
  const { loading } = useSelector((state) => state.cart);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const [open, setOpen] = useState(false);
  const [imageURL, setImageURL] = useState(null);
  const [image, setImage] = useState(null);
  const [fileType, setFileType] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [payingValidation, setPayingValidation] = useState(false);
  const [minimumPaying, setMinimumPaying] = useState(false);
  const profile = JSON.parse(localStorage.getItem('cred')).profile;

  const Schema = Yup.object().shape({
    paymentMode: Yup.string().required('paymentMethod is required'),
    currencyType: Yup.string().required('currency is required'),
    paymentAccountId: Yup.string().required('Payment Account is required'),
    // transactionDate: Yup.string().required("transactionDate is required"),
    transactionDate: Yup.date().nullable().required('Transaction date is required'),
    payingAmt: Yup.string().required('payingAmount is required'),
    payingAmtAed: Yup.number().when('currencyType', {
      is: 'AED',
      then: (schema) => schema.required('Paying amount in AED is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  const SchemaPaymentMethod = Yup.object().shape({
    paymentMode: Yup.string().required('paymentMethod is required'),
    payingAmt: Yup.string().required('payingAmount is required'),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cartId: paidItem.cartId || '',
      payingAmt:
        // paidItem.courseTypeId === 2
        //   ? ""
        //   :
        paidItem.courseTypeId === 2 && paidItem.selectedOption !== null
          ? paidItem?.classRoomNextPayment
          : paidItem.courseTypeId !== 1 && paidItem.selectedOption === null
          ? ''
          : emi
          ? paidItem.balanceAmt
          : paidItem?.selectedOptionTerms !== null
          ? paidItem?.selectedOptionTerms[0]
          : '',
      paymentProof: '',
      paymentMode: '',
      currencyType: paidItem?.selectedCurrency === 1 ? 'INR' : paidItem?.selectedCurrency === 3 ? 'AED to INR' : 'AED',
      transactionDate: null,
      paymentAccountId: '',
      payingAmtAed: '',
      remarks: '',
    },
    validationSchema: () => (formik.values?.paymentMode == 0 ? SchemaPaymentMethod : Schema),
    onSubmit: (values) => {
      if (!compressesImg && values?.paymentMode != 0) {
        enqueueSnackbar('Please upload payment screenshot..!', {
          variant: 'error',
        });
      } else {
        dispatch(makeNextPayment(values)).then((res) => {
          if (res.payload.status === 'failed' || res.payload.status === 'error') {
            enqueueSnackbar(res.payload.message, { variant: 'error' });
          } else if (res.payload.status === 'success') {
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
            if (emi) {
              dispatch(getEmiCartItem(updateData));
              dispatch(savePaginationData({ ...paginationData, openAnchor: false }));
            } else {
              handleClose();
              dispatch(getCartItemsSkillx(location?.state.leadId));
            }
            setOpen(false);
          }
        });
      }
    },
  });

  useEffect(() => {
    if (inrValue) {
      formik.setFieldValue('payingAmtAed', inrValue * formik.values.payingAmt);
    }
  }, [open, inrValue, formik.values.payingAmt]);

  useEffect(() => {
    if (paidItem && formik.values.payingAmt) {
      if (parseFloat(paidItem?.balanceAmt) >= parseFloat(formik.values.payingAmt)) {
        setPayingValidation(false);
      } else {
        setPayingValidation(true);
      }
    } else {
      setPayingValidation(false);
    }
    // -----------------------------------------------
    if (paidItem && paidItem.selectedOption !== null && paidItem.courseTypeId == 2) {
      if (parseFloat(formik.values.payingAmt) < parseFloat(paidItem.classRoomNextPayment)) {
        setMinimumPaying(true);
      } else {
        setMinimumPaying(false);
      }
    }
  }, [paidItem, formik.values.payingAmt]);

  // useEffect(() => {
  //   if (
  //     paidItem &&
  //     paidItem.selectedOption !== null &&
  //     paidItem.projectId == 1
  //   ) {

  //   }
  // }, [paidItem]);
  useEffect(() => {
    formik.setFieldValue('paymentProof', compressesImg);
  }, [compressesImg]);
  useEffect(() => {
    if (compressesImg) {
      setLoading(false);
    }
  }, [compressesImg]);
  const paymentMethods = [
    { id: '0', name: 'Generate Link' },
    { id: '1', name: 'Cash In hand' },
    { id: '2', name: 'Bank Transfer' },
    { id: '3', name: 'Stripe' },
    { id: '4', name: 'EMI' },
  ];
  const filteredPaymentMethods =
    paidItem?.selectedCurrency === 2 ? paymentMethods.filter((method) => method.id !== '0') : paymentMethods;
  const handleImageChange = (e) => {
    setImage(null);
    setCompressesImg(null);
    setLoading(true);

    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setLoading(false);
        enqueueSnackbar('File size should not exceed 2 MB', {
          variant: 'error',
        });
        return;
      }

      setImage(file);
    } else {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (image) {
      setFileType(true);
      const fileType = image.type;
      if (fileType === 'application/pdf') {
        const pdfUrl = URL.createObjectURL(image);
        setImageURL(pdfUrl);
        setCompressesImg(image);
      } else {
        compressImage(image, 0.5).then((compressedFile) => {
          const compressedUrl = compressedFile;
          const imageURL = URL.createObjectURL(compressedFile);
          setImageURL(imageURL);
          setCompressesImg(compressedUrl);
          setFileType(false);
        });
      }
    }
  }, [image]);

  // useEffect(() => {
  //   if (value) {
  //     formik.setFieldValue("transactionDate", dayjs(value).format());
  //   }
  // }, [value]);

  useEffect(() => {
    if (!open) {
      setImage(null);
      formik.setFieldValue('paymentMode', '');
      setCompressesImg('');
    }
  }, [open]);

  const handlePayingAmountChange = (event) => {
    if (event.target.value) {
      formik.setFieldValue('payingAmt', event.target.value);
    }
  };

  return (
    <GlobalDialog
      title="Select Payment Method"
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'sm'}
      closeButton={true}
      popupButton={
        <>
          {paidItem.paymentCompletionStatus == 1 ? null : (
            <Button onClick={() => setOpen(true)} variant="outlined" size="small">
              Next Payment
            </Button>
          )}
        </>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              {open ? (
                <GlobalWrapper>
                  <Box>
                    <MotionContainer delay={0.5}>
                      <Box pb={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Chip
                          size="small"
                          color="primary"
                          variant="outlined"
                          label={
                            <Box>
                              <Typography variant="h6">
                                {emi ? `EMI Amount : ${paidItem?.balanceAmt}` : ''}
                                {emi ? null : (
                                  <>
                                    {paidItem.courseTypeId === 1 && paidItem.selectedOption !== null
                                      ? `Current Term Amount : ${
                                          paidItem?.selectedOptionTerms !== null ? paidItem?.selectedOptionTerms[0] : ''
                                        }`
                                      : `Pending Amount : ${paidItem?.balanceAmt}`}
                                  </>
                                )}
                              </Typography>
                            </Box>
                          }
                        />
                      </Box>
                    </MotionContainer>
                    <Box pb={2}>
                      {paidItem.courseTypeId == 1 ? (
                        <MotionContainer delay={0.5}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Terms</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={`${formik.values.payingAmt}`}
                              label="Terms"
                              onChange={handlePayingAmountChange}
                            >
                              {paidItem?.selectedOptionTerms?.map((item, index) => {
                                return (
                                  <MenuItem keys={index} value={item}>
                                    {item}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </MotionContainer>
                      ) : (
                        <MotionContainer delay={0.5}>
                          <TextField
                            name="payingAmt"
                            label="Paying amount"
                            type="number"
                            disabled={
                              paidItem.courseTypeId === 2
                                ? false
                                : paidItem.courseTypeId === 2 && paidItem.selectedOption == null
                                ? false
                                : true
                            }
                            value={formik.values.payingAmt}
                            fullWidth
                            onChange={formik.handleChange}
                            error={formik.touched.payingAmt && Boolean(formik.errors.payingAmt)}
                            helperText={formik.errors.payingAmt}
                          />
                        </MotionContainer>
                      )}
                    </Box>
                    {payingValidation ? (
                      <Box pb={2}>
                        <MotionContainer delay={0.5}>
                          <Alert severity="warning">The added amount is greater than the pending amount...!</Alert>
                        </MotionContainer>
                      </Box>
                    ) : null}
                    {minimumPaying ? (
                      <Box pb={2}>
                        <MotionContainer delay={0.5}>
                          {' '}
                          <Alert severity="warning">
                            The minimum paying amount should greater thar or equal to {paidItem.classRoomNextPayment}
                          </Alert>
                        </MotionContainer>
                      </Box>
                    ) : null}

                    <MotionContainer delay={0.5}>
                      <Box>
                        <GlobalSelectField
                          options={{
                            name: 'paymentMode',
                            formik,
                            sx: { width: '100%' },
                            label: 'Payment Methods',
                            data: filteredPaymentMethods,
                            keys: {
                              id: 'id',
                              value: 'name',
                            },
                          }}
                        />
                      </Box>
                    </MotionContainer>
                    {formik.values.paymentMode == 0 ? null : (
                      <>
                        <Stack direction={'column'} spacing={2}>
                          <MotionContainer delay={0.5}>
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                pt: 3,
                              }}
                            >
                              <Card
                                sx={{
                                  textAlign: 'center',
                                  padding: 2,
                                  width: '100%',
                                }}
                              >
                                <Typography variant="h6" gutterBottom>
                                  Upload Proof
                                </Typography>
                                {loadingCart ? (
                                  <Loader3D />
                                ) : (
                                  <>
                                    <input
                                      accept="image/jpeg, image/png, image/webp, application/pdf"
                                      style={{ display: 'none' }}
                                      id="upload-image"
                                      type="file"
                                      onChange={handleImageChange}
                                    />
                                    <label htmlFor="upload-image">
                                      <Button variant="contained" component="span">
                                        Choose File
                                      </Button>
                                    </label>
                                    {compressesImg && !fileType && (
                                      <CardMedia
                                        component="img"
                                        image={imageURL}
                                        alt="Uploaded file preview"
                                        sx={{
                                          marginTop: 2,
                                          width: '100%',
                                          objectFit: 'cover',
                                        }}
                                      />
                                    )}
                                    <Box>{imageURL}</Box>
                                    {fileType ? (
                                      <div style={{ textAlign: 'center' }}>
                                        <Document
                                          file={image}
                                          onLoadSuccess={onDocumentLoadSuccess}
                                          loading="Loading PDF..."
                                        >
                                          <Page pageNumber={pageNumber} />
                                        </Document>

                                        <p>
                                          Page {pageNumber} of {numPages}
                                        </p>
                                        <div>
                                          <button
                                            onClick={() => setPageNumber((prev) => Math.max(prev - 1, 1))}
                                            disabled={pageNumber === 1}
                                          >
                                            Previous
                                          </button>
                                          <button
                                            onClick={() => setPageNumber((prev) => Math.min(prev + 1, numPages))}
                                            disabled={pageNumber === numPages}
                                          >
                                            Next
                                          </button>
                                        </div>
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </Card>
                            </Box>
                          </MotionContainer>
                          <MotionContainer delay={0.7}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                sx={{ width: '100%' }}
                                label="Transaction Date"
                                disableFuture
                                value={formik.values.transactionDate}
                                // minDate={profile?.isReportingHead ? null : dayjs().subtract(2, 'day')}
                                onChange={(newValue) => {
                                  formik.setFieldValue('transactionDate', newValue);
                                }}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    name: 'transactionDate',
                                    error: formik.touched.transactionDate && Boolean(formik.errors.transactionDate),
                                    helperText: formik.touched.transactionDate && formik.errors.transactionDate,
                                    onBlur: formik.handleBlur,
                                    readOnly: true,
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </MotionContainer>
                          <MotionContainer delay={0.6}>
                            <GlobalSelectField
                              options={{
                                name: 'paymentAccountId',
                                formik,
                                sx: { width: '100%' },
                                label: 'Paymemt Account',
                                data: [
                                  { id: 1, value: 'Indian A/c' },
                                  { id: 2, value: 'GCC A/c' },
                                ],
                                keys: {
                                  id: 'id',
                                  value: 'value',
                                },
                              }}
                            />
                          </MotionContainer>
                          <MotionContainer delay={0.7}>
                            <GlobalSelectField
                              options={{
                                name: 'currencyType',
                                formik,
                                sx: { width: '100%' },
                                label: 'Currency',
                                data: [
                                  { id: 'INR', name: 'INR' },
                                  { id: 'AED', name: 'AED' },
                                  { id: 'AED to INR', name: 'AED to INR' },
                                ],
                                keys: {
                                  id: 'id',
                                  value: 'name',
                                },
                              }}
                              disabled
                            />
                          </MotionContainer>
                          {formik.values.currencyType && formik.values.currencyType === 'AED' ? (
                            <>
                              {' '}
                              <MotionContainer delay={1}>
                                <TextField
                                  label="Enter INR amount for 1 AED"
                                  type="number"
                                  disabled
                                  onChange={(e) => setInrValue(e.target.value)}
                                  value={inrValue}
                                  fullWidth
                                  // onWheel={(e) => e.target.blur()}
                                  inputProps={{
                                    inputMode: 'decimal',
                                    pattern: '[0-9]*[.]?[0-9]+',
                                    onWheel: (e) => e.target.blur(),
                                  }}
                                />
                              </MotionContainer>
                              <MotionContainer delay={1}>
                                <TextField
                                  name="payingAmtAed"
                                  label="AED Amount"
                                  type="number"
                                  disabled
                                  onChange={formik.handleChange}
                                  value={formik.values.payingAmtAed}
                                  fullWidth
                                  onWheel={(e) => e.target.blur()}
                                  inputProps={{
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*',
                                    onWheel: (e) => e.target.blur(),
                                  }}
                                  error={formik.touched.payingAmtAed && Boolean(formik.errors.payingAmtAed)}
                                  helperText={formik.touched.payingAmtAed && formik.errors.payingAmtAed}
                                />
                              </MotionContainer>
                            </>
                          ) : null}
                          <MotionContainer delay={1}>
                            <TextField
                              name="remarks"
                              label="Remarks"
                              onChange={formik.handleChange}
                              value={formik.values.remarks}
                              fullWidth
                              multiline
                              rows={3}
                            />
                          </MotionContainer>
                        </Stack>
                      </>
                    )}

                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        padding: 2,
                      }}
                    >
                      <Stack direction={'row'} spacing={1}>
                        <CancelButton size="small" action={() => setOpen(false)}>
                          Cancel
                        </CancelButton>
                        {formik.values.paymentMode == 0 ? (
                          <Button
                            type="submit"
                            size={smUp ? 'medium' : 'small'}
                            sx={{
                              color: 'white',
                              background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                              borderRadius: 3,
                            }}
                            disabled={loading || payingValidation || minimumPaying ? true : false}
                          >
                            <Icon icon="mdi:cart-outline" height={22} width={22} />
                            {loading ? (
                              <Box sx={{ display: 'flex' }}>
                                Please Wait...!
                                <CircularLoader />
                              </Box>
                            ) : (
                              'Generate Link'
                            )}
                          </Button>
                        ) : (
                          <Button
                            size={smUp ? 'medium' : 'small'}
                            type="submit"
                            sx={{
                              color: 'white',
                              background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                              borderRadius: 3,
                            }}
                            disabled={loading || payingValidation || minimumPaying ? true : false}
                          >
                            <Icon icon="mdi:cart-outline" height={22} width={22} />
                            {loading ? (
                              <Box sx={{ display: 'flex' }}>
                                Please Wait...!
                                <CircularLoader />
                              </Box>
                            ) : (
                              'Make Payment'
                            )}
                          </Button>
                        )}
                      </Stack>
                    </Box>
                  </Box>
                </GlobalWrapper>
              ) : null}
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default MakeNextPayment;
